import type { List } from 'app/generated/graphql'
import type { CustomPageJson, CustomPages } from 'app/types/entities'

export const LIST_ENTITY_TYPE: Readonly<Record<CustomPages, string>> = {
  contacts: `Contact`,
  tasks: `Task`,
  activities: `Activity`,
  appointments: `Appointment`,
  treatmentPlans: `TreatmentPlan`,
}

/** A saved list in the shape of the saved page its record page and the sidebar already read. */
export function savedPageOfList(
  list: Pick<List, `id` | `name` | `join` | `filters`>,
  page: CustomPages,
): CustomPageJson {
  return { id: list.id, name: list.name, page, join: list.join ?? `and`, filters: list.filters ?? [] }
}

export function savedPagesOf(lists: readonly List[] | undefined, page: CustomPages): CustomPageJson[] {
  return (lists ?? [])
    .filter((list) => list.entityType === LIST_ENTITY_TYPE[page] && !list.system && !list.id.startsWith(`system:`))
    .map((list) => savedPageOfList(list, page))
}
